import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';

import api from 'API';
import { withNotificationForError } from './helper';

export const fetchAllColors = createAsyncThunk(
  'colors/fetchAllColors',
  withNotificationForError(async ({ id }) => {
    let CONFIG = api.banking.aemi.colorsAll;

    const response = await axios(CONFIG(id).AXIOS('GET'));

    return response.data.data;
  })
);

const initialState = {
  loading: false,
  list: [],
  error: null,
};

const colorsSlice = createSlice({
  name: 'colors',
  initialState: initialState,
  reducers: {
    clearColors() {
      return initialState;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchAllColors.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchAllColors.fulfilled, (state, action) => {
        state.loading = false;
        state.error = null;
        state.list = action.payload;
      })
      .addCase(fetchAllColors.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error;
      });
  },
});

export const { clearColors } = colorsSlice.actions;
export default colorsSlice.reducer;
